module.exports = __webpack_public_path__ + "static/media/halloween.a10bbe04.jpg";